// import React, { useEffect, useMemo, useState } from "react"
// import Chart from "react-apexcharts"
// import secureLocalStorage from "react-secure-storage"
// import { Card, CardBody, Row, Col, ButtonGroup, Button } from "reactstrap"
// import { fetchNodeData } from "utils/common-fetchData"
// import Select from "react-select"
// import { DigitalServiceOptionsDrop } from "utils/common-options"
// import Loader from "pages/Separate/Loader"
// /* ================= FILTER OPTIONS ================= */
// const FILTERS = [
//   { label: "1 Month", value: 1 },
//   { label: "3 Months", value: 3 },
//   { label: "6 Months", value: 6 },
//   // { label: "12 Months", value: 12 }
// ]

// /* ================= DUMMY DATA ================= */

// /* Orders performance */
// const ordersData = {
//   totalOrders: [120, 150, 180, 210, 260, 300],
//   avgOrderValue: [900, 950, 1000, 1100, 1200, 1300],
// }

// /* Traffic comparison */
// const trafficData = {
//   months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//   organic: [650, 680, 720, 760, 820, 900],
//   direct: [120, 130, 150, 160, 170, 190],
//   referral: [15, 12, 18, 20, 22, 25],
// }

// /* Local SEO */
// const localSeoData = {
//   calls: [120, 140, 160, 190, 210, 240],
//   directions: [80, 90, 110, 130, 150, 170],
//   clicks: [200, 220, 260, 300, 340, 380],
// }

// /* Keyword Ranking History (SEO-CORRECT STRUCTURE) */
// const keywordHistory = [
//   {
//     month: "Jan",
//     keywords: {
//       "SEO Services": 6,
//       "Local SEO Services": 5,
//       "Digital Marketing Agency": 8,
//     },
//   },
//   {
//     month: "Feb",
//     keywords: {
//       "SEO Services": 5,
//       "Local SEO Services": 4,
//       "Digital Marketing Agency": 7,
//     },
//   },
//   {
//     month: "Mar",
//     keywords: {
//       "SEO Services": 4,
//       "Local SEO Services": 3,
//       "Digital Marketing Agency": 6,
//     },
//   },
//   {
//     month: "Apr",
//     keywords: {
//       "SEO Services": 3,
//       "Local SEO Services": 2,
//       "Digital Marketing Agency": 5,
//     },
//   },
//   {
//     month: "May",
//     keywords: {
//       "SEO Services": 2,
//       "Local SEO Services": 2,
//       "Digital Marketing Agency": 4,
//     },
//   },
//   {
//     month: "Jun",
//     keywords: {
//       "SEO Services": 2,
//       "Local SEO Services": 1,
//       "Digital Marketing Agency": 3,
//     },
//   },
// ]

// /* ================= COMPONENT ================= */

// const SeoReportDashboard = () => {
//   const [range, setRange] = useState(6)

//   /* ================= FILTERED DATA ================= */

//   const filteredMonths = keywordHistory.slice(-range)

//   /* ================= KEYWORD SERIES ================= */

//   const keywordNames = Object.keys(filteredMonths[0].keywords)

//   const keywordSeries = keywordNames.map(keyword => ({
//     name: keyword,
//     data: filteredMonths.map(m => m.keywords[keyword]),
//   }))

//   /* ================= CHART OPTIONS ================= */

//   const commonMonths = trafficData.months.slice(-range)

//   const ordersOptions = {
//     chart: { type: "bar", toolbar: { show: false } },
//     xaxis: { categories: commonMonths },
//     plotOptions: { bar: { columnWidth: "45%" } },
//   }

//   const trafficOptions = {
//     chart: { type: "line", toolbar: { show: false } },
//     stroke: { width: 3, curve: "smooth" },
//     xaxis: { categories: commonMonths },
//   }

//   const localSeoOptions = {
//     chart: { stacked: true, toolbar: { show: false } },
//     xaxis: { categories: commonMonths },
//   }

//   const keywordOptions = {
//     chart: {
//       type: "line",
//       toolbar: { show: false },
//       zoom: { enabled: false },
//     },
//     stroke: { width: 2, curve: "smooth" },
//     markers: {
//       size: 6,
//       hover: { size: 8 },
//     },
//     xaxis: {
//       categories: filteredMonths.map(m => m.month),
//     },
//     yaxis: {
//       reversed: true, // 🔥 SEO ranking logic
//       min: 1,
//       title: { text: "Keyword Rank" },
//     },
//     tooltip: {
//       y: {
//         formatter: val => `Rank ${val}`,
//       },
//     },
//     legend: { position: "top" },
//   }

//   /* ================= RENDER ================= */
//   const [projectOptions, setProjectOptions] = useState([])
//   const [project, setProject] = useState(null)
//   const [loading, setLoading] = useState(false)

//   const token = secureLocalStorage.getItem("token")

//   useEffect(() => {
//     ; (async () => {
//       try {
//         const projectsRes = await fetchNodeData(
//           null,
//           `seoReport/getProjectKS`,
//           token
//         )

//         setProjectOptions(
//           (projectsRes.data || []).map(item => ({
//             value: item.id,
//             label: item.project_name,
//             services: DigitalServiceOptionsDrop.filter(
//               s =>
//                 (item.project_type || "")?.includes(s.value) &&
//                 (s.value == "1" || s.value == "3")
//             ),
//             seo_keywords: item.seo_keywords || "",
//           }))
//         )
//       } catch (error) {
//         console.log("Error Calling API : ", error)
//       }
//     })()
//   }, [])

//   // save keywords ranking
//   const handleFetchChartData = async e => {
//     e.preventDefault()
//     try {
//       if (!project?.value) {
//         swal("", "Please Select Project.", "warning")
//         return
//       }

//       const res = await fetchNodeData(
//         setLoading,
//         `seoReport/fetchChartData/${project.value}`,
//         // token
//       )

//       console.log(res.data)

//       if (res?.data?.success) {

//       } else {
//         swal(
//           "",
//           res?.response?.data?.message ||
//           res.message ||
//           "Something Went Wrong!",
//           "warning"
//         )
//       }

//       console.log(res)

//       // console.log(res)
//     } catch (error) {
//       console.log(error, "Something Went Wrong")
//       swal(
//         "",
//         error?.response?.data?.message ||
//         error.message ||
//         "Something Went Wrong!",
//         "error"
//       )
//     }
//   }

//   return (
//     <>
//       {/* FILTER */}

//       {loading && <Loader />}

//       <Row>
//         <Col md={12}>
//           <Card>
//             <CardBody className="d-flex justify-content-between">

//               <form onSubmit={handleFetchChartData} className="col-5 d-flex gap-3">
//                 <Select
//                   placeholder="Select Project"
//                   className="basic-multi-select w-75"
//                   classNamePrefix="select"
//                   options={projectOptions}
//                   onChange={e => {
//                     setProject(e)
//                   }}
//                   required
//                 />
//                 <button
//                   // onClick={handleFetchChartData}
//                   className=" btn text-white btn-save btn-label"
//                 >
//                   <i className="fas fa-search me-2 icon-size label-icon"></i>
//                   Search
//                 </button>
//               </form>
//               <ButtonGroup >
//                 {FILTERS.map(f => (
//                   <Button
//                     key={f.value}
//                     color={range === f.value ? "primary" : "light"}
//                     onClick={() => setRange(f.value)}
//                   >
//                     {f.label}
//                   </Button>
//                 ))}
//               </ButtonGroup>
//             </CardBody>
//           </Card>
//         </Col>

//         {/* KEYWORD RANKING */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Keyword Ranking Trend</h5>
//               <Chart
//                 type="line"
//                 height={300}
//                 options={keywordOptions}
//                 series={keywordSeries}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* ORDERS */}
//         <Col md={12}>
//           <Card>
//             <CardBody>
//               <h5>Orders Performance</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={ordersOptions}
//                 series={[
//                   { name: "Orders", data: ordersData.totalOrders.slice(-range) },
//                   {
//                     name: "Avg Order Value",
//                     data: ordersData.avgOrderValue.slice(-range),
//                   },
//                 ]}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* TRAFFIC */}
//         <Col md={12}>
//           <Card>
//             <CardBody>
//               <h5>Website Traffic Trend</h5>
//               <Chart
//                 type="line"
//                 height={300}
//                 options={trafficOptions}
//                 series={[
//                   {
//                     name: "Organic",
//                     data: trafficData.organic.slice(-range),
//                   },
//                   {
//                     name: "Direct",
//                     data: trafficData.direct.slice(-range),
//                   },
//                   {
//                     name: "Referral",
//                     data: trafficData.referral.slice(-range),
//                   },
//                 ]}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* LOCAL SEO */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Local SEO Actions</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={localSeoOptions}
//                 series={[
//                   { name: "Calls", data: localSeoData.calls.slice(-range) },
//                   {
//                     name: "Directions",
//                     data: localSeoData.directions.slice(-range),
//                   },
//                   {
//                     name: "Clicks",
//                     data: localSeoData.clicks.slice(-range),
//                   },
//                 ]}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//       </Row>
//     </>
//   )
// }

// export default SeoReportDashboard

// import React, { useEffect, useState } from "react"
// import Chart from "react-apexcharts"
// import secureLocalStorage from "react-secure-storage"
// import { Card, CardBody, Row, Col, ButtonGroup, Button } from "reactstrap"
// import { fetchNodeData } from "utils/common-fetchData"
// import Select from "react-select"
// import { DigitalServiceOptionsDrop } from "utils/common-options"
// import Loader from "pages/Separate/Loader"
// import swal from "sweetalert"

// /* ================= FILTER OPTIONS ================= */
// const FILTERS = [
//   { label: "1 Month", value: 1 },
//   { label: "3 Months", value: 3 },
//   { label: "6 Months", value: 6 },
// ]

// /* ================= HELPERS ================= */
// const monthNames = [
//   "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
// ]

// const safeJSON = value => {
//   try {
//     return JSON.parse(value)
//   } catch {
//     return null
//   }
// }

// /* ================= COMPONENT ================= */
// const SeoReportDashboard = () => {
//   const token = secureLocalStorage.getItem("token")

//   const [range, setRange] = useState(6)
//   const [loading, setLoading] = useState(false)

//   const [projectOptions, setProjectOptions] = useState([])
//   const [project, setProject] = useState(null)

//   const [months, setMonths] = useState([])

//   const [ordersSeries, setOrdersSeries] = useState([])
//   const [trafficSeries, setTrafficSeries] = useState([])
//   const [localSeoSeries, setLocalSeoSeries] = useState([])
//   const [keywordSeries, setKeywordSeries] = useState([])

//   /* ================= LOAD PROJECTS ================= */
//   useEffect(() => {
//     ; (async () => {
//       try {
//         const res = await fetchNodeData(null, "seoReport/getProjectKS", token)
//         setProjectOptions(
//           (res.data || []).map(item => ({
//             value: item.id,
//             label: item.project_name,
//             services: DigitalServiceOptionsDrop.filter(
//               s =>
//                 (item.project_type || "").includes(s.value) &&
//                 (s.value === "1" || s.value === "3")
//             ),
//           }))
//         )
//       } catch (err) {
//         console.log(err)
//       }
//     })()
//   }, [])

//   /* ================= FETCH + TRANSFORM DATA ================= */
//   const handleFetchChartData = async e => {
//     e.preventDefault()

//     if (!project?.value) {
//       swal("", "Please Select Project.", "warning")
//       return
//     }

//     try {
//       const res = await fetchNodeData(
//         setLoading,
//         `seoReport/fetchChartData/${project.value}`
//       )

//       if (!res?.success) {
//         swal("", "Failed to fetch chart data", "error")
//         return
//       }

//       const raw = res.data || []

//       /* SORT BY YEAR + MONTH */
//       const sorted = [...raw].sort(
//         (a, b) =>
//           a.report_year - b.report_year ||
//           a.report_month - b.report_month
//       )

//       /* MONTH LABELS */
//       const monthLabels = sorted.map(
//         i => monthNames[i.report_month - 1]
//       )
//       setMonths(monthLabels)

//       /* ================= ORDERS ================= */
//       setOrdersSeries([
//         {
//           name: "Total Orders",
//           data: sorted.map(i =>
//             Number(safeJSON(i.totalOrders)?.value || 0)
//           ),
//         },
//         {
//           name: "Total Order Value",
//           data: sorted.map(i =>
//             Number(safeJSON(i.totalOrderValue)?.value || 0)
//           ),
//         },
//         {
//           name: "Avg Order Value",
//           data: sorted.map(i =>
//             Number(safeJSON(i.avgOrderValue)?.value || 0)
//           ),
//         },
//       ])

//       /* ================= TRAFFIC ================= */
//       const getTraffic = (item, metric) => {
//         const traffic = safeJSON(item.traffic) || []
//         return Number(
//           traffic.find(t => t.metric === metric)?.current || 0
//         )
//       }

//       setTrafficSeries([
//         {
//           name: "Organic",
//           data: sorted.map(i => getTraffic(i, "Organic Traffic")),
//         },
//         {
//           name: "Direct",
//           data: sorted.map(i => getTraffic(i, "Direct Traffic")),
//         },
//         {
//           name: "Referral",
//           data: sorted.map(i => getTraffic(i, "Referral Traffic")),
//         },
//       ])

//       /* ================= LOCAL SEO ================= */
//       setLocalSeoSeries([
//         {
//           name: "Interactions",
//           data: sorted.map(
//             i =>
//               i.local_seo_data?.reduce(
//                 (a, b) => a + Number(b.interactions || 0),
//                 0
//               ) || 0
//           ),
//         },
//         {
//           name: "Calls",
//           data: sorted.map(
//             i =>
//               i.local_seo_data?.reduce(
//                 (a, b) => a + Number(b.calls || 0),
//                 0
//               ) || 0
//           ),
//         },
//         {
//           name: "Directions",
//           data: sorted.map(
//             i =>
//               i.local_seo_data?.reduce(
//                 (a, b) => a + Number(b.directions || 0),
//                 0
//               ) || 0
//           ),
//         },
//         {
//           name: "Clicks",
//           data: sorted.map(
//             i =>
//               i.local_seo_data?.reduce(
//                 (a, b) => a + Number(b.Click || 0),
//                 0
//               ) || 0
//           ),
//         },
//       ])

//       /* ================= KEYWORDS ================= */
//       setKeywordSeries([
//         {
//           name: "Keyword Count",
//           data: sorted.map(i => Number(i.keywords || 0)),
//         },
//       ])
//     } catch (err) {
//       console.log(err)
//       swal("", "Something went wrong!", "error")
//     }
//   }

//   /* ================= CHART OPTIONS ================= */
//   const chartX = months.slice(-range)

//   const baseXAxis = { xaxis: { categories: chartX } }

//   const ordersOptions = {
//     chart: { type: "bar", toolbar: { show: false } },
//     plotOptions: { bar: { columnWidth: "45%" } },
//     ...baseXAxis,
//   }

//   const trafficOptions = {
//     chart: { type: "line", toolbar: { show: false } },
//     stroke: { width: 3, curve: "smooth" },
//     ...baseXAxis,
//   }

//   const localSeoOptions = {
//     chart: { stacked: true, toolbar: { show: false } },
//     ...baseXAxis,
//   }

//   const keywordOptions = {
//     chart: { type: "line", toolbar: { show: false } },
//     stroke: { width: 3, curve: "smooth" },
//     markers: { size: 5 },
//     xaxis: { categories: chartX },
//     yaxis: {
//       reversed: false,
//       title: { text: "Total Keywords" },
//     },
//   }

//   /* ================= RENDER ================= */
//   return (
//     <>
//       {loading && <Loader />}

//       <Row>
//         <Col md={12}>
//           <Card>
//             <CardBody className="d-flex justify-content-between">
//               <form onSubmit={handleFetchChartData} className="col-5 d-flex gap-3">
//                 <Select
//                   placeholder="Select Project"
//                   className="w-75"
//                   options={projectOptions}
//                   onChange={setProject}
//                 />
//                 <button className="btn btn-primary text-white">
//                   Search
//                 </button>
//               </form>

//               <ButtonGroup>
//                 {FILTERS.map(f => (
//                   <Button
//                     key={f.value}
//                     color={range === f.value ? "primary" : "light"}
//                     onClick={() => setRange(f.value)}
//                   >
//                     {f.label}
//                   </Button>
//                 ))}
//               </ButtonGroup>
//             </CardBody>
//           </Card>
//         </Col>

//         {/* KEYWORDS */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Keyword Growth Trend</h5>
//               <Chart
//                 type="line"
//                 height={300}
//                 options={keywordOptions}
//                 series={keywordSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* ORDERS */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Orders Performance</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={ordersOptions}
//                 series={ordersSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* TRAFFIC */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Website Traffic Trend</h5>
//               <Chart
//                 type="line"
//                 height={300}
//                 options={trafficOptions}
//                 series={trafficSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* LOCAL SEO */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Local SEO Actions</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={localSeoOptions}
//                 series={localSeoSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </>
//   )
// }

// export default SeoReportDashboard

// import React, { useEffect, useState } from "react"
// import Chart from "react-apexcharts"
// import secureLocalStorage from "react-secure-storage"
// import { Card, CardBody, Row, Col, ButtonGroup, Button } from "reactstrap"
// import { fetchNodeData } from "utils/common-fetchData"
// import Select from "react-select"
// import { DigitalServiceOptionsDrop } from "utils/common-options"
// import Loader from "pages/Separate/Loader"
// import swal from "sweetalert"

// /* ================= FILTER OPTIONS ================= */
// const FILTERS = [
//   { label: "1 Month", value: 1 },
//   { label: "3 Months", value: 3 },
//   { label: "6 Months", value: 6 },
// ]

// /* ================= HELPERS ================= */
// const monthNames = [
//   "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
// ]

// const safeJSON = value => {
//   try {
//     return JSON.parse(value)
//   } catch {
//     return []
//   }
// }

// /* ================= COMPONENT ================= */
// const SeoReportDashboard = () => {
//   const token = secureLocalStorage.getItem("token")

//   const [range, setRange] = useState(6)
//   const [loading, setLoading] = useState(false)

//   const [projectOptions, setProjectOptions] = useState([])
//   const [project, setProject] = useState(null)

//   const [months, setMonths] = useState([])

//   const [ordersSeries, setOrdersSeries] = useState([])
//   const [trafficSeries, setTrafficSeries] = useState([])
//   const [localSeoSeries, setLocalSeoSeries] = useState([])
//   const [keywordSeries, setKeywordSeries] = useState([])

//   /* ================= LOAD PROJECTS ================= */
//   useEffect(() => {
//     ; (async () => {
//       try {
//         const res = await fetchNodeData(null, "seoReport/getProjectKS", token)
//         setProjectOptions(
//           (res.data || []).map(item => ({
//             value: item.id,
//             label: item.project_name,
//             services: DigitalServiceOptionsDrop.filter(
//               s =>
//                 (item.project_type || "").includes(s.value) &&
//                 (s.value === "1" || s.value === "3")
//             ),
//           }))
//         )
//       } catch (err) {
//         console.log(err)
//       }
//     })()
//   }, [])

//   /* ================= FETCH + TRANSFORM ================= */
//   const handleFetchChartData = async e => {
//     e.preventDefault()

//     if (!project?.value) {
//       swal("", "Please Select Project.", "warning")
//       return
//     }

//     try {
//       const res = await fetchNodeData(
//         setLoading,
//         `seoReport/fetchChartData/${project.value}`
//       )

//       if (!res?.success) {
//         swal("", "Failed to fetch data", "error")
//         return
//       }

//       const raw = res.data || []

//       /* SORT MONTHS */
//       const sorted = [...raw].sort(
//         (a, b) =>
//           a.report_year - b.report_year ||
//           a.report_month - b.report_month
//       )

//       const monthLabels = sorted.map(
//         i => monthNames[i.report_month - 1]
//       )
//       setMonths(monthLabels)

//       /* ================= ORDERS ================= */
//       setOrdersSeries([
//         {
//           name: "Total Orders",
//           data: sorted.map(i => Number(JSON.parse(i.totalOrders)?.value || 0)),
//         },
//         {
//           name: "Total Order Value",
//           data: sorted.map(i => Number(JSON.parse(i.totalOrderValue)?.value || 0)),
//         },
//         {
//           name: "Avg Order Value",
//           data: sorted.map(i => Number(JSON.parse(i.avgOrderValue)?.value || 0)),
//         },
//       ])

//       /* ================= TRAFFIC ================= */
//       const getTraffic = (item, metric) =>
//         Number(
//           safeJSON(item.traffic).find(t => t.metric === metric)?.current || 0
//         )

//       setTrafficSeries([
//         { name: "Website Visits", data: sorted.map(i => getTraffic(i, "Total Website Visits")) },
//         { name: "Organic", data: sorted.map(i => getTraffic(i, "Organic Traffic")) },
//         { name: "Direct", data: sorted.map(i => getTraffic(i, "Direct Traffic")) },
//         { name: "Referral", data: sorted.map(i => getTraffic(i, "Referral Traffic")) },
//       ])

//       /* ================= LOCAL SEO ================= */
//       const sum = (arr, key) =>
//         arr?.reduce((a, b) => a + Number(b[key] || 0), 0) || 0

//       setLocalSeoSeries([
//         { name: "Interactions", data: sorted.map(i => sum(i.local_seo_data, "interactions")) },
//         { name: "Calls", data: sorted.map(i => sum(i.local_seo_data, "calls")) },
//         { name: "Directions", data: sorted.map(i => sum(i.local_seo_data, "directions")) },
//         { name: "Clicks", data: sorted.map(i => sum(i.local_seo_data, "Click")) },
//       ])

//       /* ================= KEYWORD RANKINGS (REAL SEO) ================= */
//       const allKeywords = new Set()

//       sorted.forEach(m => {
//         const kData = m.keywords_data?.[0]
//         safeJSON(kData?.keyword).forEach(k => allKeywords.add(k.keyword.trim()))
//         safeJSON(kData?.additional).forEach(k => k.keyword && allKeywords.add(k.keyword.trim()))
//       })

//       const keywordSeriesData = [...allKeywords].map(keyword => ({
//         name: keyword,
//         data: sorted.map(m => {
//           const kData = m.keywords_data?.[0]
//           const all = [
//             ...safeJSON(kData?.keyword),
//             ...safeJSON(kData?.additional),
//           ]
//           const found = all.find(k => k.keyword?.trim() === keyword)
//           return found ? Number(found.rank) : null
//         }),
//       }))

//       setKeywordSeries(keywordSeriesData)

//     } catch (err) {
//       console.log(err)
//       swal("", "Something went wrong!", "error")
//     }
//   }

//   /* ================= CHART OPTIONS ================= */
//   const chartX = months.slice(-range)

//   const ordersOptions = {
//     chart: { type: "bar", toolbar: { show: false } },
//     xaxis: { categories: chartX },
//     plotOptions: { bar: { columnWidth: "45%" } },
//   }

//   const trafficOptions = {
//     chart: { type: "line", toolbar: { show: false } },
//     stroke: { width: 3, curve: "smooth" },
//     xaxis: { categories: chartX },
//   }

//   const localSeoOptions = {
//     chart: { stacked: true, toolbar: { show: false } },
//     xaxis: { categories: chartX },
//   }

//   const keywordOptions = {
//     chart: { type: "line", toolbar: { show: false } },
//     stroke: { width: 2 },
//     markers: { size: 5 },
//     xaxis: { categories: chartX },
//     yaxis: {
//       reversed: true,
//       min: 1,
//       title: { text: "Keyword Rank (Lower is Better)" },
//     },
//     tooltip: {
//       y: { formatter: v => (v ? `Rank ${v}` : "Not Ranked") },
//     },
//   }

//   /* ================= RENDER ================= */
//   return (
//     <>
//       {loading && <Loader />}

//       <Row>
//         <Col md={12}>
//           <Card>
//             <CardBody className="d-flex justify-content-between">
//               <form onSubmit={handleFetchChartData} className="col-5 d-flex gap-3">
//                 <Select
//                   placeholder="Select Project"
//                   className="basic-multi-select w-75"
//                   classNamePrefix="select"
//                   options={projectOptions}
//                   onChange={e => {
//                     setProject(e)
//                   }}
//                   required
//                 />
//                 <button
//                   className=" btn text-white btn-save btn-label"
//                 >
//                   <i className="fas fa-search me-2 icon-size label-icon"></i>
//                   Search
//                 </button>
//               </form>

//               <ButtonGroup>
//                 {FILTERS.map(f => (
//                   <Button
//                     key={f.value}
//                     color={range === f.value ? "primary" : "light"}
//                     onClick={() => setRange(f.value)}
//                   >
//                     {f.label}
//                   </Button>
//                 ))}
//               </ButtonGroup>
//             </CardBody>
//           </Card>
//         </Col>

//         {/* KEYWORDS */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Keyword Ranking Trend</h5>
//               <Chart
//                 type="line"
//                 height={350}
//                 options={keywordOptions}
//                 series={keywordSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* ORDERS */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Orders Performance</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={ordersOptions}
//                 series={ordersSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* TRAFFIC */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Website Traffic</h5>
//               <Chart
//                 type="line"
//                 height={300}
//                 options={trafficOptions}
//                 series={trafficSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>

//         {/* LOCAL SEO */}
//         <Col md={12} className="mt-4">
//           <Card>
//             <CardBody>
//               <h5>Local SEO Actions</h5>
//               <Chart
//                 type="bar"
//                 height={300}
//                 options={localSeoOptions}
//                 series={localSeoSeries.map(s => ({
//                   ...s,
//                   data: s.data.slice(-range),
//                 }))}
//               />
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>
//     </>
//   )
// }

// export default SeoReportDashboard

import React, { useEffect, useMemo, useState } from "react"
import Chart from "react-apexcharts"
import secureLocalStorage from "react-secure-storage"
import { Card, CardBody, Row, Col, ButtonGroup, Button } from "reactstrap"
import { fetchNodeData } from "utils/common-fetchData"
import Select from "react-select"
import { DigitalServiceOptionsDrop } from "utils/common-options"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
import { monthOptions } from "./SeoReport"

/* ================= FILTER OPTIONS ================= */
const FILTERS = [
  { label: "1 Month", value: 1 },
  { label: "3 Months", value: 3 },
  { label: "6 Months", value: 6 },
]

/* ================= HELPERS ================= */
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

export function getYearOptions(till = 2010) {
  const yearsOptions = []
  for (let year = new Date().getFullYear(); year >= till; year--)
    yearsOptions.push(year)

  return yearsOptions
}

const safeJSON = value => {
  try {
    return JSON.parse(value)
  } catch {
    return []
  }
}

/* ================= COMPONENT ================= */
const SeoReportDashboard = () => {
  const token = secureLocalStorage.getItem("token")

  const [range, setRange] = useState(6)
  const [loading, setLoading] = useState(false)

  const [projectOptions, setProjectOptions] = useState([])
  const [project, setProject] = useState(null)

  const [months, setMonths] = useState([])

  const [ordersSeries, setOrdersSeries] = useState([])
  const [trafficSeries, setTrafficSeries] = useState([])
  const [localSeoSeries, setLocalSeoSeries] = useState([])

  /* 🔹 KEYWORD STATES (ADDED) */
  const [keywordSeries, setKeywordSeries] = useState([])
  const [keywordOptions, setKeywordOptions] = useState([])
  const [selectedKeywords, setSelectedKeywords] = useState([])

  const [fromMonth, setFromMonth] = useState() // if Jan = 1
  const [toMonth, setToMonth] = useState() // if Jan = 1
  const [year, setYear] = useState(new Date().getFullYear())

  /* ================= LOAD PROJECTS ================= */
  useEffect(() => {
    ; (async () => {
      try {
        const res = await fetchNodeData(null, "seoReport/getProjectKS", token)

        setProjectOptions(
          (res.data || []).map(item => ({
            value: item.id,
            label: item.project_name,
            services: DigitalServiceOptionsDrop.filter(
              s =>
                (item.project_type || "").includes(s.value) &&
                (s.value === "1" || s.value === "3")
            ),
          }))
        )
      } catch (err) {
        console.log(err)
      }
    })()
  }, [])

  /* ================= FETCH + TRANSFORM ================= */
  const handleFetchChartData = async e => {
    e.preventDefault()

    if (!project?.value) {
      swal("", "Please Select Project.", "warning")
      return
    }

    try {
      const res = await fetchNodeData(
        setLoading,
        `seoReport/fetchChartData/${project.value}`
      )

      if (!res?.success) {
        swal("", "Failed to fetch data", "error")
        return
      }

      const raw = res.data || []

      /* SORT MONTHS */
      const sorted = [...raw].sort(
        (a, b) =>
          a.report_year - b.report_year || a.report_month - b.report_month
      )

      const monthLabels = sorted.map(i => monthNames[i.report_month - 1])
      setMonths(monthLabels)

      /* ================= ORDERS ================= */
      setOrdersSeries([
        {
          name: "Total Orders",
          data: sorted.map(i => Number(JSON.parse(i.totalOrders)?.value || 0)),
        },
        {
          name: "Total Order Value",
          data: sorted.map(i =>
            Number(JSON.parse(i.totalOrderValue)?.value || 0)
          ),
        },
        {
          name: "Avg Order Value",
          data: sorted.map(i =>
            Number(JSON.parse(i.avgOrderValue)?.value || 0)
          ),
        },
      ])

      /* ================= TRAFFIC ================= */
      const getTraffic = (item, metric) =>
        Number(
          safeJSON(item.traffic).find(t => t.metric === metric)?.current || 0
        )

      setTrafficSeries([
        {
          name: "Website Visits",
          data: sorted.map(i => getTraffic(i, "Total Website Visits")),
        },
        {
          name: "Organic",
          data: sorted.map(i => getTraffic(i, "Organic Traffic")),
        },
        {
          name: "Direct",
          data: sorted.map(i => getTraffic(i, "Direct Traffic")),
        },
        {
          name: "Referral",
          data: sorted.map(i => getTraffic(i, "Referral Traffic")),
        },
      ])

      /* ================= LOCAL SEO ================= */
      const sum = (arr, key) =>
        arr?.reduce((a, b) => a + Number(b[key] || 0), 0) || 0

      setLocalSeoSeries([
        {
          name: "Interactions",
          data: sorted.map(i => sum(i.local_seo_data, "interactions")),
        },
        {
          name: "Calls",
          data: sorted.map(i => sum(i.local_seo_data, "calls")),
        },
        {
          name: "Directions",
          data: sorted.map(i => sum(i.local_seo_data, "directions")),
        },
        {
          name: "Clicks",
          data: sorted.map(i => sum(i.local_seo_data, "Click")),
        },
      ])

      /* ================= KEYWORD RANKINGS (UPDATED) ================= */
      const allKeywords = new Set()

      sorted.forEach(m => {
        const kData = m.keywords_data?.[0]
        safeJSON(kData?.keyword).forEach(k => allKeywords.add(k.keyword.trim()))
        safeJSON(kData?.additional).forEach(k => {
          if (k.keyword) allKeywords.add(k.keyword.trim())
        })
      })

      const keywordSeriesData = [...allKeywords].map(keyword => ({
        name: keyword,
        data: sorted.map(m => {
          const kData = m.keywords_data?.[0]
          const all = [
            ...safeJSON(kData?.keyword),
            ...safeJSON(kData?.additional),
          ]
          const found = all.find(k => k.keyword?.trim() === keyword)
          return found ? Number(found.rank) : null
        }),
      }))

      const dropdownOptions = [...allKeywords].map(k => ({
        label: k,
        value: k,
      }))

      setKeywordOptions(dropdownOptions)
      setSelectedKeywords(dropdownOptions.slice(0, 5)) // default
      setKeywordSeries(keywordSeriesData)
    } catch (err) {
      console.log(err)
      swal("", "Something went wrong!", "error")
    }
  }

  /* ================= CHART OPTIONS ================= */
  const chartX = months.slice(-range)

  const ordersOptions = {
    chart: { type: "bar", toolbar: { show: false } },
    xaxis: { categories: chartX },
    plotOptions: { bar: { columnWidth: "45%" } },
  }

  const trafficOptions = {
    chart: { type: "line", toolbar: { show: false } },
    stroke: { width: 3, curve: "smooth" },
    xaxis: { categories: chartX },
  }

  const localSeoOptions = {
    chart: { stacked: true, toolbar: { show: false } },
    xaxis: { categories: chartX },
  }

  const keywordOptionsChart = {
    chart: { type: "line", toolbar: { show: false } },
    stroke: { width: 2 },
    markers: { size: 5 },
    xaxis: { categories: chartX },
    yaxis: {
      reversed: true,
      min: 1,
      title: { text: "Keyword Rank (Lower is Better)" },
    },
    tooltip: {
      y: {
        formatter: v => (v ? `Rank ${v}` : "Not Ranked"),
      },
    },
  }

  /* 🔹 FILTER KEYWORDS BASED ON SELECTION */
  const filteredKeywordSeries = keywordSeries
    .filter(s => selectedKeywords.some(k => k.value === s.name))
    .map(s => ({ ...s, data: s.data.slice(-range) }))

  /* ================= RENDER ================= */

  const yearsOptions = useMemo(
    () => getYearOptions(new Date().getFullYear() - 5),
    []
  ) 

  return (
    <>
      {loading && <Loader />}

      <Row>
        <Col md={12}>
          <Card>
            <CardBody className="d-flex justify-content-between">
              <form
                onSubmit={handleFetchChartData}
                className="col-6 d-flex gap-3"
              >
                <Select
                  placeholder="Select Project"
                  className="w-75"
                  options={projectOptions}
                  onChange={setProject}
                  required
                />

                <Select
                  placeholder="Service" 
                  options={project?.services || []}
                  // onChange={setProject}
                  required
                />

                <button className="btn btn-save text-white">Search</button>
              </form>

              <div className="col-5 d-flex gap-3">
                <select
                  className="form-select"
                  value={fromMonth}
                  onChange={e => setFromMonth(e.target.value)}
                  required
                >
                  <option value="">From Month</option>
                  {monthOptions.map((month, key) => (
                    <option key={month} value={key + 1}>
                      {month}
                    </option>
                  ))}
                </select>

                <select
                  className="form-select"
                  value={toMonth}
                  onChange={e => setToMonth(e.target.value)}
                  required
                >
                  <option value="">To Month</option>
                  {monthOptions.map((month, key) => (
                    <option key={month} value={key + 1}>
                      {month}
                    </option>
                  ))}
                </select>

                <select
                  className="form-select "
                  value={year}
                  onChange={e => setYear(e.target.value)}
                  required
                >
                  <option value="">Year</option>
                  {yearsOptions.map(year => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              {/* <ButtonGroup>
                {FILTERS.map(f => (
                  <Button
                    key={f.value}
                    color={range === f.value ? "primary" : "light"}
                    onClick={() => setRange(f.value)}
                  >
                    {f.label}
                  </Button>
                ))}
              </ButtonGroup> */}
            </CardBody>
          </Card>
        </Col>
        {project && (
          <>
            {/* ================= KEYWORDS ================= */}
            <Col md={12}>
              <Card>
                <CardBody>
                  <h5>Keyword Ranking Trend</h5>

                  <Select
                    isMulti
                    options={keywordOptions}
                    value={selectedKeywords}
                    onChange={setSelectedKeywords}
                    placeholder="Select Keywords"
                    className="mb-3"
                  />

                  <Chart
                    type="line"
                    height={350}
                    options={keywordOptionsChart}
                    series={filteredKeywordSeries}
                  />
                </CardBody>
              </Card>
            </Col>

            {/* ================= ORDERS ================= */}
            <Col md={12}>
              <Card>
                <CardBody>
                  <h5>Orders Performance</h5>
                  <Chart
                    type="bar"
                    height={300}
                    options={ordersOptions}
                    series={ordersSeries.map(s => ({
                      ...s,
                      data: s.data.slice(-range),
                    }))}
                  />
                </CardBody>
              </Card>
            </Col>

            {/* ================= TRAFFIC ================= */}
            <Col md={12}>
              <Card>
                <CardBody>
                  <h5>Website Traffic</h5>
                  <Chart
                    type="line"
                    height={300}
                    options={trafficOptions}
                    series={trafficSeries.map(s => ({
                      ...s,
                      data: s.data.slice(-range),
                    }))}
                  />
                </CardBody>
              </Card>
            </Col>

            {/* ================= LOCAL SEO ================= */}
            <Col md={12}>
              <Card>
                <CardBody>
                  <h5>Local SEO Actions</h5>
                  <Chart
                    type="bar"
                    height={300}
                    options={localSeoOptions}
                    series={localSeoSeries.map(s => ({
                      ...s,
                      data: s.data.slice(-range),
                    }))}
                  />
                </CardBody>
              </Card>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

export default SeoReportDashboard
